/* file description */
import { Button, Tabs, Badge } from 'antd';
import * as React from 'react';
import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { SPTableListPropsType, AalueChangeRrgType } from './type';
import SPTableWithModel from '@/components/SPTableWithModel';
import useValuesStore from '@/store/useValuesStore';
import { TableRefType } from '../SPTabList/type';
import { useFreeBtnClick, useOptionsColumns, useSPTableWithModelSchema, useSPTableWithModelSchemaReturnType, useInit } from './effect';
import ToolBarRender from './components/ToolBarRender';
import useMetaStore from '@/store/useMetaStore';
import _, { divide } from 'lodash';
import { getModelInitData } from '@/components/SPFormWithModel/effect';
import RuleController from '../RuleController';
import { AbilityPoint } from '@/const';

export const SPTableList: React.FC<SPTableListPropsType> = (props) => {
  const { rowId, refList, headModuleId } = props;
  const store = useValuesStore();
  const { values, setValues } = store;
  const { metaInfoByRule, isMobile } = useMetaStore();
  const tableRefList = useRef<Record<string, TableRefType>>({});
  // 生成table的props
  const { spRecordListSchema, selectedRows, setSelectedRows } = useSPTableWithModelSchema({
    schemaList: props.schema,
    rowId,
    metaInfoByRule,
  });
  const sotreState = useMetaStore((state) => state);
  const [tableValidateResult, settableValidateResult] = useState<{ [key: string]: any }>({});
  const { moduleList } = sotreState;

  // 基于规则生成的meta信息过滤模型
  const metaInfoByRuleFilter = (children: useSPTableWithModelSchemaReturnType['spRecordListSchema']) => {
    const { metaInfoByRule } = sotreState;
    return (children || []).filter((model) => {
      if (_.get(metaInfoByRule, [model.handle, 'visible']) === false) {
        return false;
      }
      return true;
    });
  };
  // 基于规则生成的meta信息过滤模型
  // const metaInfoByRuleFilter = (children: any[]) => {
  //   return (children || []).filter((model) => {
  //     if (moduleList.find((module) => module.handle === model.handle)) {
  //       return true;
  //     }
  //     return false;
  //   });
  // };

  const {
    searchParams,
    setSearchParams,
  } = useInit({
    spRecordListSchema: metaInfoByRuleFilter(spRecordListSchema),
  });

  // 自定义按钮点击
  const { freeButtonClick } = useFreeBtnClick({ refList });
  // 生成table的操作栏
  const { createOtionsColums } = useOptionsColumns({ freeButtonClick, selectedRows });

  const addTableData = (moduleCode: string, addValues?: any) => {
    // 默认值塞入行内
    const children = spRecordListSchema?.find((el: any) => el.handle === moduleCode)?.children;
    const assetModuleField = children?.find((el: any) => el?.props?.moduleID === moduleCode)?.props?.assetModuleInfo?.fields;
    const mergeColumns = assetModuleField?.map((el: any) => {
      return {
        dataIndex: el.name,
        defaultValue: el.defaultValue,
      };
    });
    const defaultValues = getModelInitData(mergeColumns);
    tableRefList.current?.[moduleCode]?.addEditRecord({ ...defaultValues, _headId: rowId, ...addValues });
  };

  const addTableDataList = (moduleCode: string, addValuesList?: any) => {
    // 默认值塞入行内
    const children = spRecordListSchema?.find((el: any) => el.handle === moduleCode)?.children;
    const assetModuleField = children?.find((el: any) => el?.props?.moduleID === moduleCode)?.props?.assetModuleInfo?.fields;
    const mergeColumns = assetModuleField?.map((el: any) => {
      return {
        dataIndex: el.name,
        defaultValue: el.defaultValue,
      };
    });
    const defaultValues = getModelInitData(mergeColumns);
    const addResult = addValuesList.map((item: any) => {
      return {
        ...defaultValues,
        _headId: rowId,
        ...item,
      };
    });
    tableRefList.current?.[moduleCode]?.addEditRecord(addResult);
  };

  const onTableValueChange = (moduleCode: string, dataSource: Array<Record<string, any>>) => {
    const moduleValue = values[moduleCode] || [];
    let otherRows = [];
    if (rowId !== undefined && rowId !== null) {
      otherRows = moduleValue.filter((x) => x._headId !== rowId);
    }
    setValues(moduleCode, [...otherRows, ...dataSource]);
  };
  useEffect(() => {
    Object.keys(tableRefList.current).forEach((moduleCode) => {
      refList.current.set(`${moduleCode},${rowId}`, tableRefList.current?.[moduleCode]);
    });
  }, []);

  // 重置value值
  const setTableValue = useCallback(({ moduleID }: AalueChangeRrgType) => {
    let dataSource: any = [];
    if (rowId !== undefined) {
      dataSource = (values[moduleID] || [])?.filter((x) => x._headId === rowId);
    } else {
      dataSource = values[moduleID] || [];
    }

    Object.keys(searchParams[moduleID] || {}).forEach((key) => {
      if (searchParams[moduleID][key] === null || searchParams[moduleID][key] === undefined) return;
      dataSource = dataSource.filter((data) => data[key] == searchParams[moduleID][key]);
    });
    return dataSource;
  }, [rowId, values, searchParams]);

  return (
    <div className="TABPAGE">
      <Tabs >
        {metaInfoByRuleFilter(spRecordListSchema).map((tab, i) => {
          const badgeKey = `${tab?.children?.[0]?.props?.moduleID}${rowId || ''}`;
          return (
            <Tabs.TabPane
              tab={(
                <Badge dot={(tableValidateResult[badgeKey] && tableValidateResult[badgeKey].length > 0)} offset={[2, -2]}>
                  {tab?.props.tab}
                </Badge>
              )}
              key={tab?.props.key}
              forceRender
            >
              {(tab?.children || []).map((table) => {
                const key = `${table.props.moduleID}${rowId || ''}`;
                return (
                  <RuleController
                    moduleCode={table.props.tableBaseMode === 'view' ? table.props.moduleID : undefined}
                    ability={table.props.tableBaseMode === 'view' ? AbilityPoint.canView : undefined}
                    displayUnauthorizedInfo
                  >
                    <SPTableWithModel
                      {...table.props}
                      key={key}
                      ref={(el) => tableRefList.current[table.props.moduleID] = el}
                      searchParams={searchParams[table.props.moduleID]}
                      onSearch={(searchParamsValue: Record<string, any>) => {
                        setSearchParams({ [table.props.moduleID]: searchParamsValue });
                      }}
                      onChange={(value) => {
                        onTableValueChange(table.props.moduleID, value);
                      }}
                      value={
                        setTableValue({ moduleID: table.props.moduleID })
                      }
                      optionColumns={createOtionsColums(table)}
                      toolBarRender={[
                        <ToolBarRender
                          config={table}
                          addTableData={addTableData}
                          addTableDataList={addTableDataList}
                          metaInfoByRule={metaInfoByRule}
                          freeButtonClick={freeButtonClick}
                          moduleId={table.props.moduleID}
                          tableWithRef={tableRefList?.current?.[table.props.moduleID]}
                          selectedRows={selectedRows[table.props.moduleID]}
                          /** 批量删除 */
                          onRowMultDelete={() => {
                            if (selectedRows[table.props.moduleID] && selectedRows[table.props.moduleID].length > 0) {
                              tableRefList.current[table.props.moduleID]?.removeRowById(selectedRows[table.props.moduleID]?.map((x) => x._id));
                              setSelectedRows({ [table.props.moduleID]: [] });
                            }
                          }}
                          {...props}
                        />,
                      ]}
                      storeValue={values}
                      store={store}
                      onValidateChange={(errors: any[]) => {
                        settableValidateResult({
                          ...tableValidateResult,
                          [key]: errors,
                        });
                      }}
                      isMobile={isMobile}
                    />
                  </RuleController>

                );
              })}
            </Tabs.TabPane>
          );
        })}

      </Tabs>
    </div>
  );
};
